import { render, staticRenderFns } from "./orderRefundList.vue?vue&type=template&id=50ee8c52"
import script from "./orderRefundList.vue?vue&type=script&lang=js"
export * from "./orderRefundList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports